import React, { createContext, useContext } from 'react'

interface LogoutContextType {
  logoutSilently: () => void
}

const LogoutContext = createContext<LogoutContextType | null>(null)

export const LogoutProvider: React.FC<{ logoutSilently: () => void; children: React.ReactNode }> = ({
  logoutSilently,
  children
}) => {
  return <LogoutContext.Provider value={{ logoutSilently }}>{children}</LogoutContext.Provider>
}

export const useLogout = () => {
  const context = useContext(LogoutContext)
  if (!context) {
    throw new Error('useLogout must be used within a LogoutProvider')
  }
  return context
}
